import { ChangeDto, ChangeRequestDto } from 'src/api/FiretrolApiClient';
import { changeApiClient } from 'src/api/FiretrolApiClientInstances';
import { createModuleMutations } from 'src/api/queries/workflowModules/createModuleMutations';
import { queryKeys } from 'src/api/queries/queryKeys';

const mutations = createModuleMutations<ChangeDto, ChangeRequestDto>({
  label: 'change',
  saveOp: 'change.save',
  detailKey: queryKeys.changes.detail,
  getId: (dto) => dto.id,
  save: (jobId, request) =>
    changeApiClient.createOrUpdateChange(jobId, request),
  attachFromDocument: (jobId, documentId) =>
    changeApiClient.attachFromDocument(jobId, { documentId }),
  rotateExternalAccess: (jobId, id) =>
    changeApiClient.rotateExternalAccess(jobId, id),
  uploadTempFile: (file, category) =>
    changeApiClient.uploadTempFile(
      { data: file, fileName: file.name },
      category,
    ),
  generatePdf: (jobId, id) => changeApiClient.generateChangePdf(jobId, id),
  previewPdf: (jobId, id) => changeApiClient.previewChangePdf(jobId, id),
  logPdf: (jobId, statuses, contactId) =>
    changeApiClient.getChangeOrderLogPdf(jobId, statuses, contactId),
});

export const useSaveChange = mutations.useSave;
export const useAttachChangeDocument = mutations.useAttachFromDocument;
export const useUploadChangeTempFile = mutations.useUploadTempFile;
export const useRotateChangeExternalAccess = mutations.useRotateExternalAccess;
export const useGenerateChangePdf = mutations.useGeneratePdf;
export const usePreviewChangePdf = mutations.usePreviewPdf;
export const useChangeLogPdf = mutations.useLogPdf;
